import React, {Component} from 'react';
import firebase from "../firebase";
import {Redirect} from "react-router-dom";

class LogOut extends Component {
    state={redirect:false};
    componentDidMount(){
        const self = this;
        firebase.auth().signOut().then(function() {
            self.setState({redirect:true})
        }).catch(function(error) {
            console.log(error);
        });
    }
    render() {
        if (this.state.redirect) {return <Redirect to={'/'} />}
        return (
            <div>Wait..</div>
        );
    }
}

export default LogOut;